import Box from '@mui/material/Box'
import { alpha } from '@mui/material/styles'
import { brand } from '../../../styles/theme'

/** O horário de uma carga, em chip. Em destaque, o horário que mudou. */
export function ChipDeHorario({ horario, destaque }: { horario: string; destaque?: boolean }) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 64, height: 32, px: 1.25,
        borderRadius: '10px', fontWeight: 700, fontSize: '0.9rem', fontVariantNumeric: 'tabular-nums',
        border: '1px solid',
        ...(destaque
          ? { bgcolor: alpha(brand.folha, 0.16), borderColor: brand.folha, color: 'text.primary' }
          : { bgcolor: alpha(brand.floresta, 0.06), borderColor: alpha(brand.floresta, 0.22), color: brand.floresta }),
      }}
    >
      {horario}
    </Box>
  )
}
